/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
var platform_browser_1 = require('@angular/platform-browser');
exports.INTERNAL_BROWSER_PLATFORM_PROVIDERS = platform_browser_1.__platform_browser_private__.INTERNAL_BROWSER_PLATFORM_PROVIDERS;
exports.getDOM = platform_browser_1.__platform_browser_private__.getDOM;
//# sourceMappingURL=platform_browser_private.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/platform-browser-dynamic/platform_browser_private.js
 ** module id = 329
 ** module chunks = 2
 **/